import { UiService } from 'modules/ui';

import { ZENDESK_EXAMPLE_KEY, ZENDESK_EXAMPLE_SCRIPT } from './constants';
import { extractToken } from './helpers';

import Request from '@hotmart/request';

class ZendeskService {
  async getData() {
    const responseData = { loading: false };
    const zendeskConfig = await Request('config.getZendeskConfig');
    const serverToken = extractToken(zendeskConfig.codeSnippet);

    if (serverToken) {
      Object.assign(responseData, {
        widgetActive: zendeskConfig.active,
        scriptZendesk: ZENDESK_EXAMPLE_SCRIPT.replace(
          ZENDESK_EXAMPLE_KEY,
          serverToken
        )
      });
    }

    return responseData;
  }

  async updateZendeskConfig(token, active) {
    try {
      await Request('config.updateZendesk', { token, active });
      UiService.setAlertSuccess('done');
    } catch (error) {
      UiService.handleError(error);
    }
  }

  async deleteZendeskConfig() {
    try {
      await Request('delete.zendeskScript');
      UiService.setAlertSuccess('done');
    } catch (error) {
      UiService.handleError(error);
    }
  }
}

export default new ZendeskService();
